import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0019',
    ecrans: ['00-2']
});
